module.exports = __webpack_public_path__ + "static/media/cocinafacil_mobile.59ff52f9.svg";